// Init the PostsQuery Class
import {JsonProvider} from "leaflet-geosearch";

export default class CustomProvider extends JsonProvider {

    getCookie(name) {
        let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

    async search({query}) {
        let cookie = this.getCookie('bearer_token')
        let headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + cookie,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'OPTIONS, GET'
        });
        let response = await fetch('https://apis.creasrv.net/osm_search?q=' + query, {
            mode: 'cors',
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        })
        const json = await response.json();

        return this.parse({data: json});
    }

    parse({data}) {
        // Note that `data` is the raw result returned by the server. This
        // method should return data in the SearchResult format.
        return data.map((r) => ({
            x: Number(r.lon),
            y: Number(r.lat),
            label: r.display_name,
            bounds: [
                [parseFloat(r.boundingbox[0]), parseFloat(r.boundingbox[2])], // s, w
                [parseFloat(r.boundingbox[1]), parseFloat(r.boundingbox[3])], // n, e
            ],
            raw: r,
        }));
    }
}
